<template>
  <div class="setting-menu-container">
    <button
      class="sm-button"
      @click="toggleShow"
    >
      <img
        src="@shared/assets/img/general/menu.svg"
        alt="menu"
      >
    </button>
    <div
      :class="[
        show ? 'active' : '',
        'sm-menu-drop',
      ]"
    >
      <button
        v-for="option in options"
        :key="option.label"
        :class="[
          option.class ? option.class : '',
          'sm-menu-button',
          option.disable ? 'disable' : '',
        ]"
        @click="handleAction(option.action)"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SACSettingMenu',
  props: {
    options: Array,
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    document.querySelector(':not(.sm-menu-drop)').addEventListener('click', this.closeOnClick);
  },
  destroyed() {
    document.querySelector(':not(.sm-menu-drop)').removeEventListener('click', this.closeOnClick);
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    handleAction(action) {
      if (action) {
        action();
      }
      this.show = false;
    },
    closeOnClick(e) {
      if (!e.target.closest('.sm-menu-drop') && !e.target.closest('.sm-button') && this.show) {
        this.show = false;
      }
    },
  },
};
</script>

<style lang="scss">

.setting-menu-container {
  display: flex;
  justify-content: flex-end;
  position: relative;
  width: 100%;

  .sm-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $WHITE;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    margin-left: 10px;
    cursor: pointer;

    &:hover {
      background-color: $N20;
    }
  }

  .sm-menu-drop {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    z-index: 10;
    top: 45px;
    background-color: $WHITE;
    width: 200px;
    border-radius: 6px;
    transform: scaleY(0);
    transform-origin: top;
    transition: .1s transform ease;

    &.active {
      height: auto;
      transform: scaleY(1);
      box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1);
    }

    .sm-menu-button {
      padding: 12px 0;
      font-weight: 500;

      &:not(:last-child) {
        border-bottom: 1px solid $N20;
      }

      &:first-child {
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;
      }

      &:last-child {
        border-bottom-right-radius: 6px;
        border-bottom-left-radius: 6px;
      }

      &.blue-btn {
        background: $NBLUE100;
        color: $WHITE;
      }

      &.common-btn {
        background-color: $WHITE;
        color: $BLACK;
        &:hover {
          background: $NBLUE100;
          color: $WHITE;
        }
      }

      &.red-btn {
        background: $TOMATO100;
        color: $WHITE;
      }

      &.disable {
        opacity: 0.5;
        pointer-events: none;
      }
    }
  }
}
</style>
